import React, { useState, useEffect, useRef } from 'react';
import { classList } from 'utils/componentsCommon';
import PropTypes from 'prop-types';

const InfoDialog = ({ initialContent, modalContent, headerContent, footerContent, onClose, className, marker, modal, color, showClose = true, ...props }) => {
    const [classNames, setClassName] = useState('');
    const classListRef = useRef(classNames);

    useEffect(() => {
        classListRef.current = classList('infoDialog', modal ? 'modal' : '', color ? `color-${color}` : '', className);
        setClassName(classListRef.current);
    }, [modal, className, color]);

    useEffect(() => {
        const body = document.querySelector('body');

        if (modal) body.classList.add('modal');

        return () => {
            body.classList.remove('modal');
        };
    }, [modal]);

    return (
        <div className={ classNames }>
            <div>
                { headerContent }
                <div className="content">
                    { showClose && (
                        <a onClick={ onClose }>
                            <div></div>
                        </a>
                    ) }
                    <div className="inner" { ...props }>
                        { marker && !modal && <div className="marker">{ marker }</div> }
                        { !modal ? <div className="content">{ initialContent }</div> : <div className="modalContent">{ modalContent }</div> }
                    </div>
                </div>
                { footerContent }
            </div>
        </div>
    );
};

InfoDialog.propTypes = {
    initialContent: PropTypes.element,
    modalContent: PropTypes.element,
    headerContent: PropTypes.element,
    footerContent: PropTypes.element,
    onClose: PropTypes.func,
    className: PropTypes.string,
    marker: PropTypes.string,
    modal: PropTypes.bool,
    color: PropTypes.string,
    showClose: PropTypes.bool,
    props: PropTypes.array,
};

export default InfoDialog;
